import React, { useEffect, useState } from "react";
import { Card, Button, Row, Col, Modal, Form } from "react-bootstrap";
import { rewardService } from "../services";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import "react-toastify/dist/ReactToastify.css";

function RewardsPage() {
  const [rewards, setRewards] = useState([]);

  const [selectedReward, setSelectedReward] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isGift, setIsGift] = useState(false);
  const [email, setEmail] = useState("");

  const location = useLocation();
  const { rewardId } = location.state || {};

  useEffect(() => {
    getRewardsList();
  }, []);

  useEffect(() => {
    if (rewardId && rewards.length > 0) {
      const rewardToOpen = rewards.find((r) => r.id === rewardId);
      if (rewardToOpen) {
        handleCardClick(rewardToOpen);
      }
    }
  }, [rewardId, rewards]);

  // Fetch Rewards List
  const getRewardsList = async () => {
    try {
      const res = await rewardService.getRewards();
      if (res && res.data) {
        setRewards(res.data);
        //  toast.success(res.message);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  // Handle Reward Claim
  const getClaimRewards = async (rewardId) => {
    try {
      const res = await rewardService.getClaimRewards({ rewardId });
      if (res) {
        if (res.success) {
          // toast.success(res.message || "Reward claimed successfully!");
          getRewardsList();
        } else {
          toast.error(res.message || "Something went wrong while claiming reward.");
        }
      }
    } catch (error) {
      toast.error(error?.message || "An unexpected error occurred.");
    }
  };
  

  //  Handle Gift Card
  const handleSendGift = async () => {
    if (!email) return;
    try {
    const res =  await rewardService.getGiftRewards({
        rewardId: selectedReward.id,
        toEmail: email,
      });
      if (res && res.data) {
        setShowModal(false);
        toast.success(res.message);
        setEmail("");
        getRewardsList();
      }
    
    } catch (error) {
      toast.error("Error sending gift");
    }
  };

  // Card_Click_complete
  const handleCardClick = (reward, isGiftMode = false) => {
    setSelectedReward(reward);
    setIsGift(isGiftMode);
    setShowModal(true);
  };

  return (
    <div className="tab-content-container type-record1">
      <Card className="reward-card p-5">
        {/* <h5>Rewards</h5> */}
         <h5>Redeem</h5>
        <p className="section-subtitle">
          Check out which rewards you are eligible to redeem here. Either enjoy
          it for yourself or gift it to someone else.
        </p>

        {rewards && rewards.length > 0 ? (
          rewards.map((reward, index) => (
            <Card
              key={index}
              className="reward-card"
              onClick={() => handleCardClick(reward)}
            >
              <Row className="no-guttersb responsive-mb">
                <Col md={5} className="position-relative">
                  <Card.Img
                    src={reward.image}
                    alt="Reward"
                    className="reward-image"
                  />
                  <div className="points-label">
                    {reward.pointsValue} Points
                  </div>
                </Col>

                <Col md={7} className="position-relative23">
                  <Card.Body>
                    <Card.Title className="reward-title">
                      {reward.title}
                    </Card.Title>
                    <Card.Text
                      className="reward-desc change-ds1"
                      // dangerouslySetInnerHTML={{ __html: reward.description }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(reward.description, {
                          FORBID_ATTR: ['style'],
                          FORBID_TAGS: ['style'],
                        }),
                      }}
                    ></Card.Text>
                    <Button
                      className="me-2 redeem-btn custom-bt-design1"
                      style={{
                        color: "#FB4C41",
                        border: "1px solid #FB4C41",
                        borderRadius: "0",
                        backgroundColor: "white",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); 
                        getClaimRewards(reward.id, index);
                      }}
                      // disabled={reward.isClaimed}
                    >
                     {reward.isClaimed ? "CLAIMED" : "CLAIM"}
                    </Button>
                    <Button
                      className="gift-btn custom-bt-design1"
                      style={{
                        color: "#FB4C41",
                        border: "1px solid #FB4C41",
                        borderRadius: "0",
                        backgroundColor: "white",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(reward, true);
                      }}
                      // disabled={reward.isGiftToOther}
                    >
                      GIFT TO OTHERS
                    </Button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          ))
        ) : (
          <p className="text-center my-4 text-muted">No rewards found.</p>
        )}
      </Card>

      {/* Modal */}
      {selectedReward && (
        <Modal
          className="modelpopup222 bglc"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <div className="popupall">
            <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
            <Modal.Body className="popupbody">
            {selectedReward.image && (
              <div className="model-points-all">
                <img
                  src={selectedReward.image}
                  alt="rewards"
                  className="img-fluid rounded mb-3"
                />

                {/* <Card.Body> */}
                <div
                  className="model-points-label"
                >
                  {selectedReward.pointsValue} Points
                </div>
              </div>
                )}

              <h5 className="fw-bold">{selectedReward.title}</h5>

              <p className="text-muted first">
                {" "}
                Expiry: {selectedReward.expiryDate}
              </p>
              <br />
              <p className="text-muted first">
                Locations: {selectedReward.locationName}
              </p>
              <p
                className="text-muted second"
                // dangerouslySetInnerHTML={{
                //   __html: selectedReward.description,
                // }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(selectedReward.description, {
                    FORBID_ATTR: ['style'],
                    FORBID_TAGS: ['style'],
                  }),
                }}
              ></p>
              {isGift ? (
                <>
                  <Form.Group>
                    <Form.Label>Gift to other members. Enter their loyalty email below:</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter it here"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{ marginBottom: "15px" }}
                    />
                  </Form.Group>

                  <div className="big-img-bt">
                    <Button onClick={handleSendGift} className="popupButton">
                      SEND
                    </Button>
                  </div>
                </>
              ) : (
                <div className="big-img-bt">
                  <Button
                    onClick={() => setShowModal(false)}
                    className="popupButton"
                  >
                    CLOSE
                  </Button>
                </div>
              )}
            </Modal.Body>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default RewardsPage;
